import makeStyles from '@mui/styles/makeStyles';
import { getBrandCustom } from "../utils/getCustomColor";

const styles = makeStyles(() => ({
  topPanel: {
    paddingBottom: "15px",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    display: "flex",
  },
  leftSide: {
    width: "100vw",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
  },
  leftItem: {
    marginLeft: "10px",
  },
  rightItem: {
    marginRight: "10px",
  },
  title: {
    color: getBrandCustom("primaryColor", "#38CFC4"),
    fontFamily: "Inter",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0em",
    marginRight: "10px",
    textAlign: "left",
    whiteSpace: "nowrap",
  },
}));

export default styles;
